var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIconBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.91683C15.75 6.00016 13.1667 3.8335 10 3.8335C7.5 3.8335 5.33333 5.16683 4.16667 7.25016C1.83333 7.66683 0 9.66683 0 12.1668C0 14.9168 2.25 17.1668 5 17.1668C5.83333 17.1668 14.9167 17.1668 15.8333 17.1668C18.1667 17.1668 20 15.3335 20 13.0002C20 10.9168 18.5 9.16683 16.5 8.91683ZM8.33333 11.3335V8.00016H11.6667V11.3335H14.1667L10 15.5002L5.83333 11.3335H8.33333Z",
    fill: "#716158"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconBig);
export default __webpack_public_path__ + "static/media/download-icon-big.f00fa0101f15351335773e4545ea7f09.svg";
export { ForwardRef as ReactComponent };